import { Box, TextField, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface TextInputProps {
  label?: string;
  value: string | number;
  placeholder?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const TextInput = ({
  label,
  value,
  placeholder,
  onChange,
  disabled = false,
}: TextInputProps) => {
  const theme = nawyTheme;

  return (
    <Box>
      {label && (
        <Typography
          color={theme.nawy.colors.semantic.text.secondary}
          sx={{
            ...theme.nawy.typography.english.variants.body.xs.regular,
          }}
        >
          {label}
        </Typography>
      )}
      <TextField
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: theme.nawy.radius.lg,
            background: disabled
              ? theme.nawy.colors.semantic.layer.extension.disabledLight
              : theme.nawy.colors.semantic.layer.primary,
            "& fieldset": {
              border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
            },
          },
          "& .MuiInputBase-input": {
            ...theme.nawy.typography.english.variants.body.md.regular,
            height: "36px",
            padding: "0 12px",
          },
        }}
      />
    </Box>
  );
};

export default TextInput;
